import CellWithEditWrapper from 'ui-component/DataGrid/Cell/CellWithEditWrapper';
import { ReactNode } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { PermissionScope } from 'types/apps';
import { Icon } from '@tabler/icons-react';

// Used for `renderCell` option on editable columns
// Allows for rendering a cell with an edit button via handleStartEdit arg
// Used in place of a datagrid where double-clicking a cell begins editing

export type RenderCellWithEditWrapperProps = {
  params: GridRenderCellParams;
  renderMethod?: null | ((params: GridRenderCellParams) => ReactNode);
  permissionScope?: PermissionScope;
  disabled?: boolean;
  getIsDisabled?: (params: GridRenderCellParams) => boolean;
  tooltip?: string;
  icon?: Icon;
};

function renderCellWithEditWrapper({
  params,
  renderMethod,
  permissionScope,
  disabled,
  getIsDisabled,
  tooltip,
  icon,
}: RenderCellWithEditWrapperProps) {
  return (
    <CellWithEditWrapper
      params={params}
      renderMethod={renderMethod}
      permissionScope={permissionScope}
      disabled={disabled}
      getIsDisabled={getIsDisabled}
      tooltip={tooltip}
      icon={icon}
    />
  );
}

export default renderCellWithEditWrapper;
